import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Title = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.UpdatePersonalDetails
  );

  return (
    <Stack color={'text.secondary'} alignItems={'center'} gap={'8px'}>
      <Typography variant={'h2'} tabIndex={0}>
        {dictionary.title}
      </Typography>
      <Typography variant={'body3'} tabIndex={0}>
        {dictionary.subTitle}
      </Typography>
    </Stack>
  );
};
